var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('section',{staticClass:"app-content"},[_c('div',[_vm._v("\n                MMF "),_c('h1',[_vm._v(_vm._s(_vm.$t("app.title")))])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-title"},[_c('div',[_c('h1',[_vm._v("Unauthorized")])])])
}]

export { render, staticRenderFns }